import { InvoiceHistoryTabView } from "../../../ar/src/InvoiceHistoryTabView";
import { MovementTabView } from "../MovementTabView";
import { Orders } from "../Orders";
import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutOrderTabView extends Layout {
    layoutInvoiceHistoryTabView: InvoiceHistoryTabView;
    layoutMovementTabView: MovementTabView;
    layoutOrders: Orders;
}
